import PropTypes from 'prop-types'

import TablePlaceholder from '../../members/components/TablePlaceholder'

// Empty-state placeholder for the Enrollments & Billing table, matching Figma:
// - filters applied  -> "No Results" + Clear button
// - search applied    -> "No Results" + try-different hint
// - nothing at all    -> "No Transactions & Enrollments" + marketing link
const EnrollmentsEmptyState = ({ hasFilters, hasSearch, onClearAll, onLearnMore }) => {
  if (hasFilters) {
    return (
      <TablePlaceholder
        message='No Results'
        description='No Results for your Filtering, Clear your filters and try something else.'
        actionLabel='Clear'
        onAction={onClearAll}
      />
    )
  }

  if (hasSearch) {
    return (
      <TablePlaceholder
        message='No Results'
        description='No Results for your Search, Try something different.'
      />
    )
  }

  return (
    <TablePlaceholder
      message='No Transactions & Enrollments'
      description='Share & Market your Programs to your community!'
      linkLabel='Learn More About Marketing'
      onLink={onLearnMore}
    />
  )
}

EnrollmentsEmptyState.propTypes = {
  hasFilters: PropTypes.bool,
  hasSearch: PropTypes.bool,
  onClearAll: PropTypes.func,
  onLearnMore: PropTypes.func,
}

export default EnrollmentsEmptyState
